import { POS_DETAILS } from "../VocabularyCenter/optionConstants";

export const deleteUrlParams = (key: any) => {
  let uri = window.location.toString();
  let clean_uri = uri.substring(0, uri.indexOf(key));
  window.history.replaceState({}, document.title, clean_uri);
};

export const addWordToList = (openAddWordDialog: any, setAddNewWord: any) => {
  openAddWordDialog(true);
  setAddNewWord(true);
}

export const addUrlParams = (title: any, param: any) => {
  if (window.history?.state) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(title, param);
    let newUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?" +
      searchParams.toString();
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

export const topicSelected = (addUrlParams: any, setWordListDetails: any, setShowWordLists: any, setVocabCenterMainPage: any, topicLevelDetail: any) => {
  addUrlParams("topic", topicLevelDetail.headerTitle);
  setWordListDetails(topicLevelDetail);
  setShowWordLists(true);
  setVocabCenterMainPage((prevValue: any) => {
    return { ...prevValue, showVocabCenterBanner: false, topicName: topicLevelDetail.headerTitle }
  })
}

export const removeSpecialCharacters = (providedWord: any) => {
  switch (providedWord) {
    case "Industry_Word_Lists":
      return "Industry word lists";
    case "Topic_Word_Lists":
      return "Topic word lists";
    case "userWordlists":
      return "My word lists";
    case "organizationWordlists":
      return "Company Word Lists"
    default:
      return "Company word lists";
  }
}

export const getSearchedWordDetails = (infoDetails: any) => {
  if (infoDetails && Object.keys(infoDetails).length > 0) {
    return infoDetails;
  }
};

export const getParameterByName = (key: any) => {
  const match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
  const result = match && decodeURIComponent(match[1].replace(/\+/g, " "));
  return result;
};

export const isDeletable = (wordDetails: any, reduxState: any) => {
  const usersWordList = reduxState.vocabularyContents.headerLevelContents?.User["userWordlists"];
  if (usersWordList && usersWordList.length > 0) {
    const isAvailableInUsersList = usersWordList.findIndex((userList: any) => userList.listId === wordDetails.listId);
    return isAvailableInUsersList !== -1;
  }
};

export const handleCheckedOptions = (e: any, options: any, forceUpdate: any) => {
  const optionToToggle = options.find((option: any) => option.name === e.target.name);
  if (optionToToggle) {
    optionToToggle.checked = !optionToToggle.checked;
  }
  forceUpdate();
};

export const getPosValue = (value: any) => {
  let returnValue = "";
  POS_DETAILS.forEach((posDetails: any) => {
    if (posDetails && posDetails.posId === value) {
      returnValue = posDetails.pos;
    }
  });
  return returnValue;
};